import { Segmented as AntdSegmented } from "antd"
import styles from "./index.module.less"

const Segmented = props => {
  return <AntdSegmented className={styles.segmented} {...props} />
}

export default Segmented
